import playerOverrides from "./data.json";

export const renderPlayerName = (playerName: string) => {
  const override = playerOverrides.find(
    (overridePlayer) => overridePlayer.summonerName.toLowerCase() === playerName.toLowerCase())
  return override ? override.displayName : playerName;
};
